// extracted by mini-css-extract-plugin
module.exports = {"chevron":"SidebarGroupsItemChevron__chevron__21E2J","satin":"SidebarGroupsItemChevron__satin__IvFC-","success":"SidebarGroupsItemChevron__success__gJfYk"};